import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Hash } from "lucide-react";

export const UnitsPanel = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(null);
  const load = () => { setError(false); api.get("/model/units").then((r) => setData(r.data)).catch(() => setError(true)); };
  useEffect(load, []);
  return (
    <div className="bg-white border border-slate-200/80 rounded-xl p-5 shadow-sm" data-testid="units-panel">
      <div className="flex items-start gap-2">
        <Hash className="w-4 h-4 text-teal-600 mt-0.5" aria-hidden="true" />
        <div>
          <h3 className="font-heading text-sm font-bold text-slate-900">Units &amp; denominators</h3>
          <p className="text-xs text-slate-500 mt-0.5 max-w-3xl">{data?.policy || "Separate, substantiated counts — click any count to see its underlying records."}</p>
        </div>
      </div>
      {!data && !error && <p className="text-[11px] text-slate-400 flex items-center gap-1.5 mt-3" role="status"><Loader2 className="w-3 h-3 animate-spin" aria-hidden="true" />Loading counts…</p>}
      {error && <p className="text-[11px] text-red-600 mt-3" role="alert">Counts could not be loaded. <Button variant="outline" className="h-6 text-[10px]" onClick={load}>Retry</Button></p>}
      {data && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3">
            {data.units.map((u) => (
              <button key={u.id} onClick={() => setOpen(open === u.id ? null : u.id)}
                aria-expanded={open === u.id} aria-label={`${u.label}: ${u.substantiated ? u.value : "not substantiated"} — show underlying records`}
                data-testid={`unit-${u.id}`}
                className={`text-left border rounded-lg px-3 py-2 hover:border-teal-400 ${open === u.id ? "border-teal-500 bg-teal-50/40" : "border-slate-200"}`}>
                <p className="font-mono text-[9px] uppercase tracking-wide text-slate-400">{u.label}</p>
                <p className={`font-heading text-lg font-bold ${u.substantiated ? "text-slate-900" : "text-slate-400"}`}>
                  {u.substantiated ? u.value : "—"}
                </p>
                {!u.substantiated && <p className="text-[9px] text-amber-700 font-semibold">Not substantiated — withheld</p>}
              </button>
            ))}
          </div>
          {open && (() => {
            const u = data.units.find((x) => x.id === open);
            return (
              <div className="mt-3 border border-slate-200 rounded-lg p-3 max-h-56 overflow-y-auto" data-testid={`unit-drilldown-${u.id}`}>
                <p className="text-[10.5px] text-slate-600 mb-1.5"><span className="font-semibold">{u.label}:</span> {u.basis}</p>
                {u.items.length === 0 && <p className="text-[10.5px] text-slate-400">No underlying records exist for this count.</p>}
                {u.items.map((it, i) => (
                  <p key={i} className="text-[10.5px] text-slate-600 border-b border-slate-50 py-0.5">
                    <span className="font-mono text-teal-700">{it.id}</span> {it.label && <span className="text-slate-500">— {it.label}</span>}
                  </p>
                ))}
              </div>
            );
          })()}
        </>
      )}
    </div>
  );
};
